export default "__VITE_ASSET__DHkLzTCH__"